import React from "react";
import { MEDFLYT_DECORATIVE_LOGO } from "../utils/svgs_new";
import { withDefault } from "../utils/withDefault";
import { AppIcon } from "./Generic/AppIcon";

interface Props {
  color: "primary" | "black" | "white" | (string & {});
  size?: number;
}

const MedFlytDecorativeLogo = (props: Props) => {
  return (
    <AppIcon
      className="MedFlytDecorativeLogo"
      icon={MEDFLYT_DECORATIVE_LOGO}
      fill={props.color}
      size={withDefault(props.size, 60)}
    />
  );
};

export default React.memo(MedFlytDecorativeLogo);
